import 'js/src/libs/set-webpack-nonce';
import 'core-js/stable';
import 'js/src/libs/page-initialization';
import 'bootstrap';
import 'regenerator-runtime/runtime';

import 'css/src/global';

import React from 'react';

import ABWFranchisePage from 'js/src/components/abw-franchise';
import PublicPagesTrim from 'js/src/components/common/public-pages/PublicPagesTrim';
import { getPricingRootReducer } from 'js/src/entry-points/root-reducers/pricing-reducers';
import { ErrorReporter, Project } from 'js/src/libs/error-reporter';
import { createReduxStore, renderWithRedux } from 'js/src/libs/redux-utils';

ErrorReporter.init(Project.FRONTEND);

const ABWFranchisePageContainer: React.FC = React.memo(function ABWFranchisePageContainer() {
    return (
        <PublicPagesTrim headerBackgroundColor={'#FFF'}>
            <ABWFranchisePage />
        </PublicPagesTrim>
    );
});

const store = createReduxStore(getPricingRootReducer());
renderWithRedux(ABWFranchisePageContainer, store);
